"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "user.selectionUsers";
  var componentName = "selectUsers";

  var bindings = {
    selectedIds: "=",
    position: "="
  };

  var templateUrl = "app/pages/users/selectionUsers/selectionUsers.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $scope, $timeout, UsersService, CustomListsService, AgGridService, ModalService) {
      _classCallCheck(this, Controller);

      this.log = debug("pages:users:selection");

      this.log(moduleName + "/" + componentName);

      this.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.UsersService = UsersService;
      this.CustomListsService = CustomListsService;
      this.AgGridService = AgGridService;
      this.ModalService = ModalService;

      this.columnDefs = [this.AgGridService.text("firstName", "Prénom"), this.AgGridService.text("lastName", "Nom"), this.AgGridService.text("email", "Email"), AgGridService.button("btDelete", "Retirer", this.delete, this, {
        width: 90
      })];

      this._id = Math.random().toString(36).substring(7);

      this.log("_id", this._id);
    }

    _createClass(Controller, [{
      key: "loadUsersArray",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pattern) {
          var positions;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.log("position=", this.position);

                  if (!(this.position == "Formateur LVR" && !this.userArray)) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 4;
                  return this.UsersService.getLvrTrainerArray();

                case 4:
                  this.userArray = _context.sent;
                  _context.next = 31;
                  break;

                case 7:
                  if (!(this.position == "Formateur" && !this.userArray)) {
                    _context.next = 13;
                    break;
                  }

                  _context.next = 10;
                  return this.UsersService.getCustomerTrainerArray();

                case 10:
                  this.userArray = _context.sent;
                  _context.next = 31;
                  break;

                case 13:
                  if (!(this.position == "TousHorsConducteur" && !this.userArray)) {
                    _context.next = 22;
                    break;
                  }

                  _context.next = 16;
                  return this.UsersService.getPositionArray(this.$rootScope.$selectedCustomerId);

                case 16:
                  positions = _context.sent;
                  _context.next = 19;
                  return this.UsersService.remoteSelectArray(positions.map(function (position) {
                    if (position.value != "Conducteur") {
                      return position.value;
                    }
                  }));

                case 19:
                  this.userArray = _context.sent;
                  _context.next = 31;
                  break;

                case 22:
                  if (!this.position) {
                    _context.next = 28;
                    break;
                  }

                  _context.next = 25;
                  return this.UsersService.getArrayByPosition(this.position, pattern);

                case 25:
                  this.userArray = _context.sent;
                  _context.next = 31;
                  break;

                case 28:
                  _context.next = 30;
                  return this.UsersService.getArray(null, pattern);

                case 30:
                  this.userArray = _context.sent;

                case 31:

                  this.$timeout(function () {});

                case 32:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function loadUsersArray(_x) {
          return _ref.apply(this, arguments);
        }

        return loadUsersArray;
      }()
    }, {
      key: "createUser",
      value: function createUser() {
        var _this = this;

        this.ModalService.open("users/user", {}).then(function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(user) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this.loadUsersArray();

                  case 2:
                    _this.selectedIds.push("$" + user._id);
                    _this.updateTable();

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }()).catch(function () {});
      }
    }, {
      key: "envChanged",
      value: function envChanged(evt) {
        var index = this.selectedIds.indexOf(this.selectedUser.value);

        if (index == -1) {
          this.selectedIds.push(this.selectedUser.value);
          this.updateTable();
        }
      }
    }, {
      key: "delete",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row, ctx) {
          var deleteElement, index;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return swal({
                    title: "Voulez-vous retirer " + row.lastName + " " + row.firstName + " ?",

                    icon: "warning",
                    dangerMode: true,

                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  deleteElement = _context3.sent;


                  if (deleteElement) {
                    index = ctx.selectedIds.indexOf("$" + row._id);


                    if (index > -1) {
                      ctx.selectedIds.splice(index, 1);
                      ctx.updateTable();
                    }
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function _delete(_x3, _x4) {
          return _ref3.apply(this, arguments);
        }

        return _delete;
      }()
    }, {
      key: "updateTable",
      value: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var _this2 = this;

          var selectedUsers, indexUser, userId, user;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!this.selectedIds) {
                    _context4.next = 18;
                    break;
                  }

                  selectedUsers = [];
                  indexUser = 0;

                case 3:
                  if (!(indexUser < this.selectedIds.length)) {
                    _context4.next = 14;
                    break;
                  }

                  userId = this.selectedIds[indexUser];

                  if (userId) {
                    _context4.next = 8;
                    break;
                  }

                  this.selectedIds.splice(indexUser, 1);
                  return _context4.abrupt("continue", 12);

                case 8:
                  _context4.next = 10;
                  return this.UsersService.find({
                    filter: {
                      where: { _id: userId.replace("$", "") },
                      fields: { _id: 1, firstName: 1, lastName: 1, email: 1 }
                    }
                  });

                case 10:
                  user = _context4.sent;


                  if (user && user[0]) {
                    user[0].btDelete = {
                      text: '<i class="fa fa-eraser"></i> Retirer',
                      color: "custom"
                    };
                    selectedUsers.push(user[0]);
                    indexUser++;
                  } else {
                    console.log("no user for " + userId);
                    this.selectedIds.splice(indexUser, 1);
                  }

                case 12:
                  _context4.next = 3;
                  break;

                case 14:

                  this.rawData = selectedUsers;

                  this.$timeout(function () {
                    _this2.needToBeUpdate = true;
                  });
                  _context4.next = 19;
                  break;

                case 18:
                  this.selectedIds = [];

                case 19:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function updateTable() {
          return _ref4.apply(this, arguments);
        }

        return updateTable;
      }()
    }, {
      key: "$onInit",
      value: function $onInit() {
        var _this3 = this;

        this.loadUsersArray();

        this.$scope.$watch(function () {
          return _this3.selectedIds;
        }, function () {
          console.log("this.selectedIds", _this3.selectedIds);

          _this3.updateTable();
        });
      }
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();